import { NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [NgStyle]
})
export class ButtonComponent {

  @Input() id: string;
  @Input() customClass: string;
  @Input() isDisabled = false;
  @Input() type = 'primary';
  @Input() fontColor: string;
  @Input() backgroundColor: string;
  @Input() ariaLabel: string;
  @Input() ariaControls: string;
  @Input() ariaExpanded: boolean;
  @Input() ariaPressed: boolean;
  @Input() ariaDescribedby: string;

  @Output() clickEvent = new EventEmitter<void>();

  onClick(): void {
    if (!this.isDisabled) {
      this.clickEvent.emit();
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (!this.isDisabled && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      this.onClick();
    }
  }
}
